import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentComment } from '../models/document-comment/document-comment';
import { PanelList } from '../../shared/models/panel-list';
import { FilterMenu } from '../../shared/models/filter-menu';
import { SortMenu } from '../../shared/models/sort-menu';
import { DocumentPersistenceService } from '../services/document-persistence.service';

@Component({
  selector: 'app-document-comment-modal',
  templateUrl: './document-comment-modal.component.html',
  styleUrls: ['./document-comment-modal.component.scss']
})
export class DocumentCommentModalComponent implements OnInit{
  @Input() documentComment?:DocumentComment[] | null;
  @Input() documentNumber!:string;
  @Input() documentVersion!:string;
  @Input() isAddCommentButtonVisible!: boolean;
  @Output() isDocumentCommentModalShow = new EventEmitter<boolean>();
  @Input() openDocumentCommentModal ?:  boolean ;
  showLoader: boolean = false;
  showPanelList : boolean = false;
  noResultFound:boolean = false;
  resetDocumentComments: boolean = false;
  documentCommentModalInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    enableSelection: false,
  };
  openAddDocumentSlider: boolean = false
  constructor(private documentPersistenceService : DocumentPersistenceService) {
    
  }
  ngOnInit(): void {
    if(this.documentComment == null || this.documentComment == undefined || this.documentComment!.length == 0 ){
      this.noResultFound = true;
      this.documentCommentModalInput.filters = [];
      this.documentCommentModalInput.sort = [];
      this.showPanelList = true;
    }
    else{
      this.loadData();
    }
    this.documentPersistenceService.documentComments$.subscribe((documentComments)=>{
        this.documentComment = documentComments;
        this.loadData();
        this.noResultFound = false;
      })
    }

   loadData(){
    this.documentCommentModalInput.lists = this.documentComment;
    this.documentCommentModalInput.filters = this.getFilter();
    this.documentCommentModalInput.sort = this.getSortField();
    this.showPanelList = true;
    this.showLoader = false;
   }

  closeModal(){
    this.isDocumentCommentModalShow.emit(false);
  }
  addComment(){
    this.openAddDocumentSlider = true
  }
  isSliderActive(isSliderActive : boolean){
    this.openAddDocumentSlider = isSliderActive;
    if(this.resetDocumentComments)
      this.showPanelList = isSliderActive;
  }

  reloadDocumentComments(ifReloadDocuments : boolean){
    this.resetDocumentComments = ifReloadDocuments;
  }
  
  getFilter = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Created By',
        filterFieldName: 'createdBy',
      })
    return filters;
  }

  getSortField = (): SortMenu[] => {
    let sortMenu : SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Created By',
        sortFieldName: 'createdBy',
      }
    )
    return sortMenu;
  }

  ngOnDestroy= () => {
    this.documentPersistenceService.documentComments$.unsubscribe();
  }


}
